import React from 'react';
import { Button } from '../core/Button';

export function ConfirmSheet({ open, title, body, summary, onCancel, onConfirm }) {
  if (!open) return null;

  return (
    <div className="ds-confirm-sheet" role="dialog" aria-modal="true">
      <div className="ds-confirm-sheet__panel">
        <h2 className="ds-confirm-sheet__title">{title}</h2>
        {body ? <p className="ds-confirm-sheet__body">{body}</p> : null}
        {summary ? <div className="ds-confirm-sheet__summary">{summary}</div> : null}
        <div className="ds-confirm-sheet__actions">
          <div>
            <Button variant="outline" onClick={onCancel} block>
              Cancelar
            </Button>
          </div>
          <div>
            <Button variant="solid" onClick={onConfirm} block>
              Sí, enviar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function Toast({ message, visible }) {
  if (!visible) return null;
  return <div className="ds-toast" role="status">{message}</div>;
}

export default ConfirmSheet;
